var SegmentedControlViewMode;
(function (SegmentedControlViewMode) {
    SegmentedControlViewMode["HORIZONTAL_NO_WRAP"] = "horizontal-no-wrap";
    SegmentedControlViewMode["HORIZONTAL_WRAP"] = "horizontal-wrap";
})(SegmentedControlViewMode || (SegmentedControlViewMode = {}));
export { SegmentedControlViewMode, };
//# sourceMappingURL=segmented-control-constants.js.map